import { amplifyException } from '../../constants/amplify-api-constants'

export const serviceErrorWrapper = (exception) => {
  const { request, response } = exception
  const error = {
    code: response?.data?.errorCode || exception?.code || null,
    status: response?.data?.status || response?.status || 0,
    message: response?.data?.message || exception?.message || null,
    request,
    response,
  }

  /* When AWS Cognito throws unauthorized error */
  if (exception === amplifyException.USER_IS_NOT_AUTHENTICATED) {
    error.message = exception
  }

  /* When Axios is not able to intercept the error
     This is happening for http 404 and 500 series errors
     TODO:  Look into possible CORS issue */
  if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
    error.message =
      'The application encountered an error and cannot fulfill your request.  Please try again later.'
  }

  /* Transform the message when below errors occur */
  if ((!error.message && error.status === 400) || error.code === 'ERR_BAD_REQUEST') {
    error.message =
      'The server does not understand the request sent from your browser. If the issue persists, please try again later.'
  }

  if (!error.message && error.status === 401) {
    error.message =
      "You've been redirected to the login page because your session has expired.  Please try logging in again."
  }

  return error
}
